import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "py-3 container" }
const _hoisted_2 = {
  key: 1,
  class: "space-y-4 flex flex-col justify-center"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "text-lg font-semibold" }, "Assign template", -1)
const _hoisted_4 = { class: "w-full justify-center flex flex-row" }
const _hoisted_5 = { class: "w-full flex flex-row items-center space-x-3" }
const _hoisted_6 = { class: "flex flex-row w-9/12 items-center space-x-3" }
const _hoisted_7 = { class: "text-md" }
const _hoisted_8 = { class: "flex flex-row w-3/12 items-center justify-end" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-6 w-6 text-primary",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor",
  "stroke-width": "2"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    d: "M12 9v3m0 0v3m0-3h3m-3 0H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z"
  })
], -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = {
  key: 0,
  class: "w-full py-3 flex flex-row justify-center"
}
const _hoisted_13 = {
  key: 1,
  class: "w-full py-5 flex flex-row justify-center"
}
const _hoisted_14 = { class: "text-lg font-semibold text-primary text-center" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" No results found. try creating a evaluation from ")
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" here ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Skeleton = _resolveComponent("Skeleton")!
  const _component_SearchInput = _resolveComponent("SearchInput")!
  const _component_Avatar = _resolveComponent("Avatar")!
  const _component_v_pagination = _resolveComponent("v-pagination")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isLoading)
      ? (_openBlock(), _createBlock(_component_Skeleton, {
          key: 0,
          option: "card"
        }))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_SearchInput, { placeholder: "Search one template" })
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data, (item, i) => {
            return (_openBlock(), _createElementBlock("div", {
              key: `item-card-${i + 1}`,
              class: "flex flex-col border border-gray-400 px-3 py-2 rounded-2xl hover:bg-blue-200 justify-center w-full"
            }, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_Avatar, {
                    name: item.title
                  }, null, 8, ["name"]),
                  _createElementVNode("span", _hoisted_7, _toDisplayString(item.title), 1)
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("button", {
                    type: "button",
                    onClick: ($event: any) => (_ctx.assingTemplate(item.id))
                  }, _hoisted_11, 8, _hoisted_9)
                ])
              ])
            ]))
          }), 128)),
          (_ctx.data?.length > 0 && !_ctx.isLoading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createVNode(_component_v_pagination, {
                  modelValue: _ctx.page,
                  pages: _ctx.pages,
                  "range-size": 1,
                  "active-color": "#4D00C5",
                  "onUpdate:modelValue": _ctx.updateHandler
                }, null, 8, ["modelValue", "pages", "onUpdate:modelValue"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.data?.length <= 0 && !_ctx.isLoading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _createElementVNode("span", _hoisted_14, [
                  _hoisted_15,
                  _createVNode(_component_router_link, {
                    to: "/create-talent-evaluation",
                    class: "underline"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_16
                    ]),
                    _: 1
                  })
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
  ]))
}